import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export default function PrintFooterLogo() {
  const printCopy = useRef(null);
  const original = useRef(null);

  useEffect(() => {
    const media = window.matchMedia("print");
    const prepare = () => {
      if (original.current || !printCopy.current) return;
      const target = document.getElementById("print-area");
      if (!target) return;
      // Snapshot only the selected document, never the application shell.
      // The original remains mounted and its identity is restored after printing.
      const copy = target.cloneNode(true);
      original.current = target;
      target.id = "print-source-area";
      printCopy.current.appendChild(copy);
    };
    const restore = () => {
      if (original.current) original.current.id = "print-area";
      original.current = null;
      if (printCopy.current) printCopy.current.replaceChildren();
    };
    const onMediaChange = (event) => event.matches ? prepare() : restore();
    // A print-preview browser can already be in print media while the invoice
    // is still loading. Prepare once its document arrives, not only on entry.
    const observer = new MutationObserver(() => {
      if (media.matches && !original.current) prepare();
    });
    observer.observe(document.body, {
      childList: true, subtree: true, attributes: true, attributeFilter: ["id"],
    });
    media.addEventListener("change", onMediaChange);
    window.addEventListener("beforeprint", prepare);
    window.addEventListener("afterprint", restore);
    if (media.matches) prepare();
    return () => {
      observer.disconnect();
      media.removeEventListener("change", onMediaChange);
      window.removeEventListener("beforeprint", prepare);
      window.removeEventListener("afterprint", restore);
      restore();
    };
  }, []);

  if (typeof document === "undefined") return null;
  return createPortal(
    <>
      <div className="print-page-frame">
        <table className="print-page-table">
          <tbody><tr><td ref={printCopy} /></tr></tbody>
          <tfoot className="print-footer-space"><tr><td><div>&nbsp;</div></td></tr></tfoot>
        </table>
      </div>
      <div className="print-footer-logo" aria-hidden="false">
        <img src={`${process.env.PUBLIC_URL || ""}/print-assets/vgrups-footer-logo.png`} alt="VGrups" width="992" height="346" />
      </div>
    </>,
    document.body
  );
}
